module.exports = __webpack_public_path__ + "static/media/nsl-arrow.fc4d3f8f.svg";